function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#2276E3",
  fillRule: "evenodd",
  d: "M4.5 0A4.505 4.505 0 000 4.5c0 1.974 2.813 6.764 4.02 8.732a.564.564 0 00.96 0C6.186 11.265 9 6.477 9 4.5A4.505 4.505 0 004.5 0zm0 6.469a1.97 1.97 0 11.001-3.94A1.97 1.97 0 014.5 6.47z"
});

function SvgMapLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16
  }, props), _ref);
}

export default SvgMapLocationIcon;